import NotificationSimpleView from './NotificationSimpleView'

export default NotificationSimpleView
